<template>
    <div class="main-body">
        <div class="header">评估人员账号</div>
        <div class="out">

          <div class="search2">

            <div style="float:right">

              <el-select v-model="institutionCode" placeholder="请选择机构">
                <el-option
                    v-for="item in arr_ins"
                    :key="item.institutionCode"
                    :label="item.userName"
                    :value="item.institutionCode">
                </el-option>
              </el-select>
              <el-button size="mini" style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
            </div>

            <div style="clear: both;"></div>
          </div>


          <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>

            <el-table-column prop="userName" label="名称" width="200" fixed></el-table-column>
            <el-table-column prop="phone" label="手机" width="180"></el-table-column>
            <el-table-column prop="zoneName" label="组织"></el-table-column>

          </el-table>

          <div class="page">
              <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
              <div style="float: left;">
                  <el-pagination small
                          background
                          layout="prev, pager, next"
                          :total="totalItems"
                          :page-size="20"
                          :current-page.sync="currentPage"  @current-change="current_change">
                  </el-pagination>
              </div>
              <div style="clear: both;"></div>
          </div>

        </div>



    </div>
</template>

<script>


    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: "Page",

        //注册局部过滤器
        filters: {
            timefilters(val) {
                if (val == null || val == "") {
                    return "";
                } else {
                    let d = new Date(val);   //val 为表格内取到的后台时间
                    let month =
                        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
                    let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
                    let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
                    let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
                    return times;
                }
            }
        },

        data() {
            return {

                tableData: [],
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,

                batchDialog: false,
                tableLoading: false,
                workersCode: '',
                password: '',

                realName:'',
                phone:'',
                zoneCode:'',


                showModalAdd: false,
                showModalEdit: false,
                roleList: null,
                editStaff: null,
                th: 0,
                zoneValue:[],

              arr_ins:[],
              institutionCode: '',


            }
        },
        created() {
            this.getList();
            this.getIns();

            this.th = this.$store.state.tableHeight;
        },
        components: {

        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {


          getIns(){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Institution/ListType",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
                type:2,
              }
            }).then((response) => {

              if (response.data.error === 0) {
                this.arr_ins = response.data.data.list;
                if(this.arr_ins.length>0){
                  this.institutionCode = this.arr_ins[0].institutionCode;
                  this.getList();
                }
              }else if(response.data.error === 1){
                this.$message.error(response.data.message)
              }

            })

          },


          current_change: function (currentPage) {
            this.currentPage = currentPage;
            this.getList();
          },
            getList(isSearch){
                if(isSearch)this.currentPage=1

                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + 'Assess/GovPage',
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                      institutionCode:this.institutionCode,
                    }
                }).then((response) => {
                    this.tableLoading=false
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.pageInfo.list;
                        this.totalItems = response.data.data.pageInfo.total;
                    } else if (response.data.error == 1) {
                        this.$message(response.data.message);
                    } else {
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    this.tableLoading=false
                    console.log(error);
                });
            },



        }
    }
</script>

<style  lang="scss" scoped>

</style>
